/**
 * Prop the catalog slot host sets so a component can keep Puck's drop-zone
 * class. Public `className` stays omitted on components that own their spacing.
 */
export const EDITOR_HOST_CLASS_PROP = 'editorHostClassName';

/**
 * Prop the adapter sets on an inline component whose public `ref` points at
 * an inner element. The component puts it on its outermost element, which
 * then takes Puck's drag ref on the editor canvas.
 */
export const EDITOR_ROOT_REF_PROP = 'editorRootRef';
